import React, { FC } from 'react'
import { makeStyles, Theme, useTheme, Button, ButtonProps } from '@zn-material-ui'
import classNames from 'classnames'

const styles = makeStyles((theme: Theme) => ({
  root: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 0,
    paddingBottom: 0,
    height: '48px',
    width: '220px',
    lineHeight: '48px',
    fontSize: 18,
    boxShadow: 'none',
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.primary.main,
    borderRadius: 2,
    '&:active': {
      boxShadow: 'none',
    },
    '&:hover': {
      background: theme.palette.primary.main,
    },
  },
  defaultRoot: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },
}))
export interface IButtonProps extends ButtonProps {
  children: React.ReactNode
  defaultType?: boolean
}

const CButton: FC<IButtonProps> = props => {
  const { defaultType = false, ...buttonProps } = props
  const theme = useTheme()
  const classes = styles(theme)

  return (
    <Button
      classes={{
        root: classNames(classes.root, defaultType && classes.defaultRoot),
      }}
      disableFocusRipple={true}
      disableRipple={true}
      {...buttonProps}
    >
      {props.children}
    </Button>
  )
}

export default CButton
